import useCrud from './useCrud'
import useInvalidateQueries from './useInvalidateQueries'

const useProcedureCitizen = (code, token) => {
  const { findById } = useCrud(`/v1/procedures`)

  const { data: procedure, status } = findById(['procedure', code], { token }, { refetchOnWindowFocus: true })

  const invalidateQueries = useInvalidateQueries()

  const invalidateProcedureQueries = () => invalidateQueries(['procedure', code])

  return { procedure, status, invalidateProcedureQueries }
}
export default useProcedureCitizen
